// extracted by mini-css-extract-plugin
export default {"empty":"Rounds_empty__RSJM4","skeleton":"Rounds_skeleton__Srm-i"};